import React from "react";

import "./src/styles/global.scss";

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => element;
